import * as React from "react";

function SvgHoistechLogoYellow(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 504.391 172.485" {...props}>
      <g data-name="Group 136" fill="#fdc300">
        <g data-name="Group 134">
          <path
            data-name="Path 343"
            d="M29.982 49.128H14.774v123.168L0 157.522V34.354h44.755v29.225h14.451V14.774L73.98 0v78.354h-44z"
          />
          <path
            data-name="Path 344"
            d="M44.755 157.711l-14.774 14.774V94.292h44v29.225h15.208V.254l14.774 14.774v123.263H59.208v-29.225H44.757z"
          />
        </g>
        <g data-name="Group 135">
          <path
            data-name="Path 345"
            d="M153.399 93.337h-21.881v21.171h-13.585v-52.69h13.587v19.67h21.881v-19.67h13.588v52.69h-13.588z"
          />
          <path
            data-name="Path 346"
            d="M201.985 60.954c16.115 0 28.122 11.218 28.122 27.254s-12.007 27.253-28.122 27.253-28.2-11.218-28.2-27.253 12.085-27.254 28.2-27.254zm0 12.008c-8.769 0-14.377 6.635-14.377 15.246 0 8.531 5.608 15.246 14.377 15.246 8.689 0 14.3-6.715 14.3-15.246-.002-8.616-5.611-15.254-14.3-15.254z"
          />
          <path data-name="Path 347" d="M236.982 61.818h13.588v52.69h-13.588z" />
          <path
            data-name="Path 348"
            d="M263.447 96.892a23.8 23.8 0 0016.825 6.952c4.661 0 7.505-1.975 7.505-4.5 0-3-3.4-4.187-9.005-5.372-8.689-1.737-20.855-3.949-20.855-16.431 0-8.847 7.5-16.51 21.012-16.51 8.453 0 15.8 2.528 21.409 7.347l-7.426 9.716a24.49 24.49 0 00-14.851-5.45c-4.5 0-6.241 1.817-6.241 4.108 0 2.764 3.239 3.712 9.085 4.818 8.689 1.817 20.7 4.345 20.7 16.273 0 10.585-7.82 17.616-21.961 17.616-10.664 0-18.09-3.318-23.382-8.373z"
          />
          <path
            data-name="Path 349"
            d="M319.378 73.668h-14.772v-11.85h43.052v11.85h-14.694v40.84h-13.586z"
          />
          <path
            data-name="Path 350"
            d="M354.133 61.818h38.629v11.455h-25.041v8.768h24.488v11.533h-24.488v9.48h25.041v11.454h-38.629z"
          />
          <path
            data-name="Path 351"
            d="M397.982 88.203c0-16.273 12.323-27.254 28.122-27.254 13.113 0 19.907 7.189 23.383 14.14l-11.691 5.53a12.784 12.784 0 00-11.692-7.662c-8.215 0-14.3 6.635-14.3 15.246s6.083 15.246 14.3 15.246a12.785 12.785 0 0011.692-7.663l11.691 5.53c-3.4 6.793-10.27 14.14-23.383 14.14-15.799-.002-28.122-11.059-28.122-27.253z"
          />
          <path
            data-name="Path 352"
            d="M490.803 93.337h-21.881v21.171h-13.589v-52.69h13.587v19.67h21.881v-19.67h13.588v52.69h-13.588z"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgHoistechLogoYellow;
